import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { RoleService } from '../data-access/role.service';
import { map, take } from 'rxjs/operators';

export const adminGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const roleService = inject(RoleService);

    return roleService.isAdmin().pipe(
        take(1),
        map(isAdmin => {
            if (!isAdmin) {
                router.navigate(['/dashboard']);
                return false;
            }
            return true;
        })
    );
}; 